import siteConfig from "../lib/siteConfig";
const content = {
  hero: {
    title: "Asiantuntevaa hoitoa lemmikeillesi Rovaniemellä",
    subtitle: "",
    image: {
      desktop: "/images/hero-home-desktop.jpg",
      mobile: "/images/hero-home-mobile.jpg",
    },
    ctaLabel: "Varaa aika",
    ctaLink: siteConfig.bookingUrl,
  },
  servicesTitle: "Näin palvelemme",
  services: [
    {
      title: "Terveystarkastukset",
      image: "/images/mockup-image-1.jpg",
      alt: "Image alt",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque pulvinar, ante in bibendum mattis, dolor libero lacinia risus, quis efficitur est ex at libero. ",
      url: "/palvelumme#terveystarkastukset",
    },
    {
      title: "Rokotukset",
      image: "/images/mockup-image-1.jpg",
      alt: "Image alt",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque pulvinar, ante in bibendum mattis, dolor libero lacinia risus, quis efficitur est ex at libero. ",
      url: "/palvelumme#rokotukset",
    },
    {
      title: "Röntgen ja ultraääni",
      image: "/images/mockup-image-1.jpg",
      alt: "Image alt",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque pulvinar, ante in bibendum mattis, dolor libero lacinia risus, quis efficitur est ex at libero. ",
      url: "/palvelumme#rokotukset",
    },
    {
      title: "Laboratoriotutkimukset",
      image: "/images/mockup-image-1.jpg",
      alt: "Image alt",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque pulvinar, ante in bibendum mattis, dolor libero lacinia risus, quis efficitur est ex at libero. ",
      url: "/palvelumme#rokotukset",
    },
  ],
  newsFromInstagram: "Uutisia Instagramista",
  introduction: {
    title: "Tervetuloa Rovaniemen parhaimmalle eläinklinikalle",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque pulvinar, ante in bibendum mattis, dolor libero lacinia risus, quis efficitur est ex at libero. Donec finibus mattis mauris, vitae rhoncus mi porttitor eget. Phasellus ac turpis cursus, facilisis libero nec, faucibus lacus. Donec nulla ipsum, volutpat dictum quam id, tempor convallis ante.",
    link: "Lue lisää meistä",
  },
  meta: {
    title: "Eläinlääkäriasema Sinni – Hoitoa lemmikeille Rovaniemellä",
    description:
      "Sinni tarjoaa lemmikillesi kaiken tarvitTarjoamme asiantuntevaa ja ystävällistä eläinlääkäripalvelua Rovaniemellä. Ajanvaraus helposti verkossa – tervetuloa Eläinlääkäriasema Sinniin!tavan.",
  },
};

export default content;
